export function formatPrice(p) {
    return new Intl.NumberFormat(
        document.body.dataset.lang, {
            style: 'currency',
            currency: 'UAH',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(p)
        .replace('₴', '').replace(/грн.?/, '').trim()
}



//////////////////
// WEBPACK FOOTER
// ./common/index.js
// module id = SsMV
// module chunks = 1 2